export enum RolloutConfirmation {
  CLASSIC = 'CLASSIC',
  PROGRESSIVE = 'PROGRESSIVE',
  CANCEL = 'CANCEL',
}
